import React, { ReactNode } from "react"
import { useAccordionToggle } from "react-bootstrap"
import { ClassProps } from "../../utility/common/props"
import styles from "./AccordionToggle.module.scss"
import cn from "classnames"
import { testId as commonTestId } from "../../utility/tests/testId/common"

interface AccordionToggleProps extends ClassProps {
    disabled: boolean
    eventKey: string
    onToggle: () => void
    children: ReactNode
    testId?: string
}

const AccordionToggle: React.FC<AccordionToggleProps> = props => {
    const { disabled, eventKey, onToggle, children, className, testId } = props
    const onClick = useAccordionToggle(eventKey, onToggle)

    return (
        <button
            type="button"
            className={cn(styles.accordionToggle, className)}
            onClick={!disabled ? onClick : undefined}
            data-testid={testId ?? commonTestId.accordionToggle}
        >
            {children}
        </button>
    )
}

export default AccordionToggle
